import axios from 'axios';
import { createSignedPostRequest } from 'utils/createSignedRequestsHelpers';
import { CONTACTS_LOCAL_API_REQUESTS } from './utils/constants';

export const createBusinessContact = async (
  businessId,
  contactData,
  activeEmployerInfo = {}
) => {
  const apiPath = `contacts/business/${businessId}`;

  const signedRequest = await createSignedPostRequest({
    apiPath,
    body: contactData,
    activeEmployerInfo,
    isLocalApiRequest: CONTACTS_LOCAL_API_REQUESTS,
  });

  const response = await axios(signedRequest);

  return response.data;
};
